/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * HockeyCanadaIcon component - Icon for Hockey Canada question type
 *
 * Mirrors HockeyUSAIcon's membership-card glyph, with a maple-leaf mark in
 * place of the star so the two types are distinguishable in the picker.
 *
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const HockeyCanadaIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18V6ZM5 7V17H19V7H5Z'
        fill={color}
      />
      <path d='M7 9H17V11H7V9Z' fill={color} />
      <path d='M7 13H14V15H7V13Z' fill={color} />
      <path
        d='M16 11.6L16.7 12.9L18 12.5L17.5 13.8L18.6 14.2L17.3 15.1L17.5 16L16.3 15.7L16 17L15.7 15.7L14.5 16L14.7 15.1L13.4 14.2L14.5 13.8L14 12.5L15.3 12.9L16 11.6Z'
        fill={color}
      />
    </svg>
  )
}

export default HockeyCanadaIcon
